// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .container {
  width: 760px;
  position: relative;
}
:host .content {
  min-height: 300px;
}
:host .toolbox {
  position: absolute;
  right: 10px;
  top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/gauges/gauge-property/action-properties-dialog/action-properties-dialog.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/gauges/gauge-property/action-properties-dialog/action-properties-dialog.component.scss"],"names":[],"mappings":"AACI;EACE,YAAA;EACA,kBAAA;ACAN;ADGI;EACI,iBAAA;ACDR;ADGI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;ACDR","sourcesContent":[":host {\n    .container {\n      width: 760px;\n      position: relative;\n    }\n\n    .content {\n        min-height:300px;\n    }\n    .toolbox {\n        position: absolute;\n        right: 10px;\n        top: 20px;\n    }\n}",":host .container {\n  width: 760px;\n  position: relative;\n}\n:host .content {\n  min-height: 300px;\n}\n:host .toolbox {\n  position: absolute;\n  right: 10px;\n  top: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
